<template>
    <form
        action="/members-area/my-profile/#wpcf7-f91465-p91415-o3"
        method="post"
        class="wpcf7-form init mailchimp-ext-0.5.56"
        novalidate="novalidate"
        data-status="init"
    >
        <div style="display: none">
            <input type="hidden" name="_wpcf7" value="91465" />
            <input type="hidden" name="_wpcf7_version" value="5.4.1" />
            <input type="hidden" name="_wpcf7_locale" value="en_US" />
            <input
                type="hidden"
                name="_wpcf7_unit_tag"
                value="wpcf7-f91465-p91415-o3"
            />
            <input type="hidden" name="_wpcf7_container_post" value="91415" />
            <input type="hidden" name="_wpcf7_posted_data_hash" value="" />
            <input
                type="hidden"
                name="_wpcf7cf_hidden_group_fields"
                value="[]"
            />
            <input type="hidden" name="_wpcf7cf_hidden_groups" value="[]" />
            <input type="hidden" name="_wpcf7cf_visible_groups" value="[]" />
            <input type="hidden" name="_wpcf7cf_repeaters" value="[]" />
            <input type="hidden" name="_wpcf7cf_steps" value="{}" />
            <input
                type="hidden"
                name="_wpcf7cf_options"
                value='{"form_id":91465,"conditions":[],"settings":{"animation":"yes","animation_intime":200,"animation_outtime":200,"conditions_ui":"normal","notice_dismissed":false}}'
            />
        </div>
        <p class="text-center text-small">
            Legal information shared with INC accounting department.
        </p>
        <h3 class="text-center text-color-105026-color">
            Company membership details
        </h3>
        <div class="d-flex justify-content-between formStepHeader">
            <h3>Legal details</h3>
        </div>
        <p><br /></p>
        <div class="custom-grid">
            <div class="flex-float flex-6">
                <label>Legal company Name<em>*</em></label
                ><span class="wpcf7-form-control-wrap legalcompanyname"
                    ><input
                        type="text"
                        name="legalcompanyname"
                        v-model="companyModel.legal_name"
                        size="40"
                        class="wpcf7-form-control wpcf7-text wpcf7-validates-as-required"
                        aria-required="true"
                        aria-invalid="false"
                /></span>
            </div>
            <div class="flex-float flex-6">
                <label>Comercial company Name<em>*</em></label
                ><span class="wpcf7-form-control-wrap comercialcompanyname"
                    ><input
                        type="text"
                        name="comercialcompanyname"
                        v-model="companyModel.commercial_name"
                        size="40"
                        class="wpcf7-form-control wpcf7-text wpcf7-validates-as-required"
                        aria-required="true"
                        aria-invalid="false"
                /></span>
            </div>
        </div>
        <div class="custom-grid">
            <div class="flex-float flex-6 disabled">
                <label>TAX ID NUMBER (VAT, GST...)</label
                ><span class="wpcf7-form-control-wrap taxidnumber"
                    ><input
                        type="text"
                        name="taxidnumber"
                        v-model="companyModel.tax_id_number"
                        size="40"
                        class="wpcf7-form-control wpcf7-text"
                        aria-invalid="false"
                /></span>
            </div>
        </div>
        <div class="d-flex justify-content-between formStepHeader">
            <h3>Company details</h3>
        </div>
        <p><br /></p>
        <div class="custom-grid">
            <div class="flex-float flex-6">
                <label>Phone</label
                ><span class="wpcf7-form-control-wrap privatecompanyphone"
                    ><input
                        type="text"
                        name="privatecompanyphone"
                        v-model="companyModel.phone"
                        size="40"
                        class="wpcf7-form-control wpcf7-text"
                        aria-invalid="false"
                /></span>
            </div>
            <div class="flex-float flex-6">
                <label>Fax</label
                ><span class="wpcf7-form-control-wrap privatecompanyfax"
                    ><input
                        type="text"
                        name="privatecompanyfax"
                        v-model="companyModel.fax"
                        size="40"
                        class="wpcf7-form-control wpcf7-text"
                        aria-invalid="false"
                /></span>
            </div>
        </div>
        <div class="custom-grid">
            <div class="flex-float flex-6">
                <label>Email</label
                ><span class="wpcf7-form-control-wrap privatecompanyemail"
                    ><input
                        type="text"
                        name="privatecompanyemail"
                        v-model="companyModel.email"
                        size="40"
                        class="wpcf7-form-control wpcf7-text"
                        aria-invalid="false"
                /></span>
            </div>
            <div class="flex-float flex-6">
                <label>Website</label
                ><span class="wpcf7-form-control-wrap privatecompanywebsite"
                    ><input
                        type="text"
                        name="privatecompanywebsite"
                        v-model="companyModel.website"
                        size="40"
                        class="wpcf7-form-control wpcf7-text"
                        aria-invalid="false"
                /></span>
            </div>
        </div>
        <div class="custom-grid">
            <div class="flex-float flex-6">
                <label>Adress</label
                ><span class="wpcf7-form-control-wrap privatecompanyadress"
                    ><input
                        type="text"
                        name="privatecompanyadress"
                        v-model="companyModel.address"
                        size="40"
                        class="wpcf7-form-control wpcf7-text"
                        aria-invalid="false"
                /></span>
            </div>
            <div class="flex-float flex-6">
                <label>Additional information</label
                ><span
                    class="wpcf7-form-control-wrap privatecompanyadditionalinfo"
                    ><input
                        type="text"
                        name="privatecompanyadditionalinfo"
                        v-model="companyModel.additional_info"
                        size="40"
                        class="wpcf7-form-control wpcf7-text"
                        aria-invalid="false"
                /></span>
            </div>
        </div>
        <div class="custom-grid">
            <div class="flex-float flex-6">
                <label>City</label
                ><span class="wpcf7-form-control-wrap privatecompanycity"
                    ><input
                        type="text"
                        name="privatecompanycity"
                        v-model="companyModel.city"
                        size="40"
                        class="wpcf7-form-control wpcf7-text"
                        aria-invalid="false"
                /></span>
            </div>
            <div class="flex-float flex-6">
                <label>ZIP code</label
                ><span class="wpcf7-form-control-wrap privatecompanyzip"
                    ><input
                        type="text"
                        name="privatecompanyzip"
                        v-model="companyModel.zip_code"
                        size="40"
                        class="wpcf7-form-control wpcf7-text"
                        aria-invalid="false"
                /></span>
            </div>
        </div>
        <div class="custom-grid">
            <div class="flex-float flex-6">
                <label>State</label
                ><span class="wpcf7-form-control-wrap privatecompanystate"
                    ><input
                        type="text"
                        name="privatecompanystate"
                        v-model="companyModel.state"
                        size="40"
                        class="wpcf7-form-control wpcf7-text"
                        aria-invalid="false"
                /></span>
            </div>
            <div class="flex-float flex-6">
                <label>Country</label
                ><span class="wpcf7-form-control-wrap privatecompanycountry"
                    ><input
                        type="text"
                        name="privatecompanycountry"
                        v-model="companyModel.country"
                        size="40"
                        class="wpcf7-form-control wpcf7-text"
                        aria-invalid="false"
                /></span>
            </div>
        </div>
        <h3 class="text-center text-color-105026-color">INC members details</h3>
        <div class="d-flex justify-content-between formStepHeader">
            <h3>Directory contacts</h3>
        </div>
        <CompanyProfilePrivateFormContacts
            :contacts="company.contacts"
            @contacts-change="contactsChange"
        />
        <div class="text-center">
            <input
                type="submit"
                value="INC verification"
                class="wpcf7-form-control wpcf7-submit submit-btn"
                style="display: none"
            />
            <span class="ajax-loader"></span>
            <span class="btn-container btn-container-js">
                <a
                    @click="submit"
                    id="btSubmit"
                    href="#"
                    :class="{ disabled: form.disableSubmit }"
                    class="custom-link btn btn-lg border-width-0 btnCustom0 btn-default btn-icon-left submit-btn js custom-btn"
                    >Send</a
                ></span
            >
        </div>
        <p class="text-center text-small">
            *INC must approve changes to your profile in accordance with
            <a href="#">Terms &amp; Conditions</a>
        </p>
        <div class="wpcf7-response-output" aria-hidden="true">
            {{ form.requestResponse }}
        </div>
        <p style="display: none !important">
            <span class="wpcf7-form-control-wrap referer-page">
                <input
                    type="hidden"
                    name="referer-page"
                    value="http://localhost:8899/members-area/"
                    data-value="http://localhost:8899/members-area/"
                    class="wpcf7-form-control wpcf7-text referer-page"
                    aria-invalid="false"
                />
            </span>
        </p>
    </form>
</template>

<script>
import CompanyProfilePrivateFormContacts from "@/components/domain/my-profile/company-profile-form/company-profile-private-form-contacts.vue";
import { requestStatusMessage, jsonRequest } from "@/helpers/wordpress";

export default {
    props: {
        company: Object,
    },
    data() {
        return {
            companyModel: this.updateCompanyModel(this.company),
            form: {
                disableSubmit: false,
                requestResponse: "",
            },
        };
    },
    methods: {
        contactsChange(contacts) {
            this.companyModel.contacts = contacts;
        },
        updateCompanyModel(company) {
            return {
                legal_name: company.post.post_title,
                commercial_name: company.post.post_title,
                tax_id_number: "",
                phone: company.fields.telephone,
                fax: company.fields.fax,
                email: company.fields.email,
                website: company.fields.website,
                address: company.fields.address,
                additional_info: "",
                city: "",
                zip_code: "",
                state: "",
                country: company.categories.countries
                    .map((t) => t.name)
                    .join(", "),
                contacts: company.contacts,
            };
        },
        async submit(event) {
            event.preventDefault();
            this.form.disableSubmit = true;
            this.form.requestResponse = "";

            const response = await jsonRequest(
                "POST",
                "inc_members_send_company_private_changes",
                this.companyModel
            );
            this.form.requestResponse = requestStatusMessage(response);

            this.form.disableSubmit = false;
        },
    },
    watch: {
        company: {
            handle(newValue) {
                this.companyModel = this.updateCompanyModel(newValue);
            },
            deep: true,
        },
    },
    components: {
        CompanyProfilePrivateFormContacts,
    },
};
</script>

<style></style>
